import type { FaqItem } from '@/types/content';

export const faqs: FaqItem[] = [
  {
    question: '瓜田爆料的内容主要来自哪里？',
    answer:
      '站内内容以公开渠道可查的信息、行业公开活动以及内容从业者的普遍观察为基础，由编辑团队重新梳理成合集。我们不对未公开的私人信息进行挖掘，也不转载来源不明的截图与音频。',
  },
  {
    question: '网站内容会持续更新吗？',
    answer:
      '会。每个分类合集都会随话题进展补充新的条目，编辑团队通常在工作日完成一轮整理。你可以在首页看到最新发布的话题，也可以进入具体分类只看自己感兴趣的方向。',
  },
  {
    question: '怎样按分类浏览爆料？',
    answer:
      '首页的“分类合集”区域列出了全部主题，点击任意卡片即可进入该分类的合集页；在分类页顶部还可以横向切换其它分类，方便你连续浏览多个方向的内容。',
  },
  {
    question: '我可以投稿或者提供线索吗？',
    answer:
      '欢迎。你可以通过“关于我们”页面的投稿表单提交话题线索或建议，请尽量说明话题所属分类与可公开查证的背景。对于无法核实来源的内容，我们不会收录。',
  },
  {
    question: '网站如何把握内容的边界？',
    answer:
      '我们坚持三条原则：不发布未核实的私人信息、不对真实个人进行定性指控、不传播来源不明的素材。涉及具体个人的内容，一律只讨论公开可查的公开行为与行业现象。',
  },
  {
    question: '浏览瓜田爆料需要注册账号吗？',
    answer:
      '不需要。站内所有分类合集与话题详情都可以直接阅读，没有登录门槛，也不会要求你填写个人信息。',
  },
  {
    question: '如何联系网站团队？',
    answer:
      '可以通过“关于我们”页面的联系方式发送邮件，或直接使用页面上的联系表单。我们会在工作日内回复较为具体的来信。',
  },
];